export default "__VITE_ASSET__CNM23ijF__"